import { useRef, useEffect } from 'react';

// Observes a sentinel element and invokes `onLoadMore` when it scrolls into view.
// Returns a ref you should attach to the sentinel. When `hasMore` is false or
// `loading` is true, the observer is disabled so we don't double-fire.
const useInfiniteScroll = (hasMore, loading, onLoadMore) => {
  const sentinelRef = useRef(null);
  const onLoadMoreRef = useRef(onLoadMore);

  useEffect(() => {
    onLoadMoreRef.current = onLoadMore;
  }, [onLoadMore]);

  useEffect(() => {
    if (!hasMore || loading) return;
    const el = sentinelRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          onLoadMoreRef.current && onLoadMoreRef.current();
        }
      },
      { rootMargin: '200px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, loading]);

  return sentinelRef;
};

export default useInfiniteScroll;
